import ControlGroupSummary from "../js/components/controlGroup/ControlGroupSummary.react";
export default ControlGroupSummary;
